
export interface FetchRbaRateResult {
  updateRequired: boolean,
  rbaRateEffectiveDate: string,  // format:  2 Nov 2022
  rbaRateChangePercent: number,
  rbaRateTargetPercent: number,
}
